import React, { useState } from "react";
import { toast } from "react-toastify";
import { faRefresh } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { API, get } from "../../../config";
import { Button, Dropdown, DropdownButton, Modal } from "react-bootstrap";
import Spin from "../../common/Spin";
import { useParams } from "react-router-dom";
import CustomTooltip from "../../common/CustomTooltip";
import moment from "moment";
import { DatePicker } from "rsuite";

const ABARefresh = ({ id, handleRefreshButton }) => {
  const params = useParams();
  const projectId = params?.project_id;
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const [abaRegenerateDate, setAbaRegenerateDate] = useState(today);

  const toggleShowModal = () => {
    setShowModal(!showModal);
  };

  const handleRefresh = async () => {
    try {
      setLoading(true);
      const { data } = await get(
        `${
          API.REGENERATE_ABA
        }/${id}?builder_project_id=${projectId}&transaction_date=${
          abaRegenerateDate
            ? moment(abaRegenerateDate)?.format("DD-MM-YYYY")
            : ""
        }`
      );
      toast.success(data.message);
      toggleShowModal();
      setLoading(false);
      handleRefreshButton();
    } catch (e) {
      toast.error(
        "There is some issue with request, please try after some time."
      );
      setLoading(false);
    }
  };
  return (
    <>
      <CustomTooltip message={"Regenerate ABA File"}>
        <span>
          <FontAwesomeIcon
            icon={faRefresh}
            size="1x"
            onClick={() => {
              toggleShowModal();
            }}
          />
        </span>
      </CustomTooltip>
      {showModal && (
        <Modal
          size="lg"
          show={showModal}
          onHide={toggleShowModal}
          dialogClassName="modal-50w small-popup review-popup small-review"
          aria-labelledby="contained-modal-title-vcenter"
          className="project-section"
          centered
        >
          <Modal.Header className="mb-0" closeButton>
            Regenerate ABA File
          </Modal.Header>
          <div className="modal-body">
            <div className="paymentNote" style={{ marginBottom: "10px" }}>
              <p className="aba-transaction-date-label">
                <span className="required">*</span>Payment Date
                <div className="apca-info">
                  <DropdownButton className="info-icon" title="">
                    <Dropdown.Item>
                      <p>
                        {/* Select the date on which date you want to make payment
                        or you already made the payment. */}
                        Select the payment date
                      </p>
                    </Dropdown.Item>
                  </DropdownButton>
                </div>
              </p>
              <DatePicker
                cleanable={false}
                onChange={(e) => {
                  setAbaRegenerateDate(moment(e, "DD-MM-YYYY"));
                }}
                format="dd-MM-yyyy"
                value={
                  abaRegenerateDate
                    ? String(abaRegenerateDate)?.includes("-")
                      ? new Date(
                          String(abaRegenerateDate)?.split("-")[2],
                          String(abaRegenerateDate)?.split("-")[1] - 1,
                          String(abaRegenerateDate)?.split("-")[0]
                        )
                      : new Date(abaRegenerateDate)
                    : null
                }
                className="rs-date-body"
                placeholder="Select Date"
                placement="autoVerticalStart"
                style={{
                  width: "162px",
                }}
                disabledDate={(date) => moment(date).isAfter(moment())}
              />
            </div>
            <p>Are your sure you want to regenerate the .ABA File?</p>
          </div>
          <div className="modal-footer">
            <Button
              disabled={loading}
              className="cancel"
              onClick={() => toggleShowModal()}
            >
              Cancel
            </Button>
            <Button disabled={loading} onClick={handleRefresh}>
              OK
            </Button>
          </div>
          {loading && <Spin />}
        </Modal>
      )}
    </>
  );
};

export default ABARefresh;
